export default "__VITE_ASSET__BfZ$o4LL__"